import React from 'react';

export const Undefined = () => {
    return <div className={'fst-italic fw-lighter'}>Non renseigné</div>
}